module.exports = __webpack_public_path__ + "media/images/beauty-logo-eb8f8ae0494c20ebbe0690bc6809b50c.svg";